module.exports = __webpack_public_path__ + "img/nakdan-live.03d01272.png";